import { http } from '../../../../api/http';
import type { ConceptoPlanilla } from '../types/concepto';

const ENDPOINT = '/planilla/concepto';

export class ConceptoService {
  public static async getAll(): Promise<ConceptoPlanilla[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  public static async getByTipo(tipo: string): Promise<ConceptoPlanilla[]> {
    const response = await http.get(`${ENDPOINT}/tipo/${tipo}`);
    return response.data;
  }

  public static async getById(id: number): Promise<ConceptoPlanilla> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  public static async save(concepto: ConceptoPlanilla): Promise<ConceptoPlanilla> {
    const response = await http.post(ENDPOINT, concepto);
    return response.data;
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }
}
